import "./AddEditBakeryModal.css";

import BakeryForm from "../BakeryForm/BakeryForm";

function AddEditBakeryModal({
  isOpen,
  onClose,
  formData,
  updateField,
  submitForm,
  loading,
  editingProduct,
}) {
  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitForm();
  };

  return (
    <div className="bakery-modal-overlay">

      <div className="bakery-modal">

        <div className="bakery-modal-header">

          <h2>
            {editingProduct
              ? "Edit Bakery Product"
              : "Add Bakery Product"}
          </h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ✕
          </button>

        </div>

        <form onSubmit={handleSubmit}>

          <BakeryForm
            formData={formData}
            updateField={updateField}
          />

          <div className="modal-footer">

            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="save-btn"
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editingProduct
                ? "Update Product"
                : "Add Product"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default AddEditBakeryModal;